<div class="review-card">
  <dl class="review-list">
    <dt>Full Name</dt>
    <dd>{{ contactProperty()['fullName'] || '—' }}</dd>
    <dt>Email Address</dt>
    <dd>{{ contactProperty()['email'] || '—' }}</dd>
    <dt>Phone Number</dt>
    <dd>{{ contactProperty()['phone'] || '—' }}</dd>
    <dt>ZIP Code</dt>
    <dd>{{ contactProperty()['zipCode'] || '—' }}</dd>
  </dl>
</div>

<div class="review-card">
  <dl class="review-list">
    <dt>Owner Status</dt>
    <dd>{{ ownerStatusLabel() }}</dd>
    <dt>When do you plan on starting to build?</dt>
    <dd>{{ buildTimelineLabel() }}</dd>
    <dt>What are you hoping to use your ADU for?</dt>
    <dd>{{ intendedUseLabels() }}</dd>
    @if (intendedUseOtherDescription()) {
    <dt>Other Use Description</dt>
    <dd>{{ intendedUseOtherDescription() }}</dd>
    }
    <dt>What matters most to you?</dt>
    <dd>{{ primaryInterestLabels() }}</dd>
    <dt>Where did you hear about Kore?</dt>
    <dd>{{ aboutAduLabel() }}</dd>
  </dl>
</div>

<!-- <div class="review-card">
  <div class="review-card-header">
    <span class="review-card-title">Uploaded Materials</span>
    <button pButton type="button" label="Edit" class="p-button-text p-button-sm edit-link"
      (click)="editStep.emit(4)"></button>
  </div>
  @if (uploadedFiles().length) {
  <div class="file-chip-row">
    @for (file of uploadedFiles(); track file.name) {
    <p-chip [label]="file.name" [icon]="fileIcon(file)" />
    }
  </div>
  } @else {
  <p class="no-files">No files uploaded yet.</p>
  }
</div> -->

<div class="consent-list" [formGroup]="consentForm()">
  <div class="consent-item">
    <p-checkbox [binary]="true" formControlName="infoAccurate" inputId="infoAccurate" />
    <label for="infoAccurate">I confirm that the information provided is accurate.</label>
  </div>
  <div class="consent-item">
    <p-checkbox [binary]="true" formControlName="agreeTerms" inputId="agreeTerms" />
    <label for="agreeTerms">I agree to the <a href="#privacy" class="consent-link"
        (click)="$event.stopPropagation()">Privacy Policy</a> and <a href="#terms" class="consent-link"
        (click)="$event.stopPropagation()">Terms of Service</a>.</label>
  </div>
  <div class="consent-item">
    <p-checkbox [binary]="true" formControlName="agreeContact" inputId="agreeContact" />
    <label for="agreeContact">I agree that Kore may contact me regarding my property request.</label>
  </div>
</div>
